import store from '@/store'
import { PreviewVideoQualityType } from '@/types/users'
import { computed } from '@vue/composition-api'
import { hasCastersMixin } from '@/modules/classBuilder/mixins/hasCasters'

const useCastUserStatus = () => {
  const currentCast = computed(() => store.state.events.currentCast)
  const userProfile = computed(() => store.state.user.profile)
  const userPreviewQuality = computed(() => userProfile.value?.previewVideoQuality ?? PreviewVideoQualityType.High)
  const isModerator = computed(() => {
    if (currentCast.value === null) return false
    if (!hasCastersMixin(currentCast.value)) return false
    if (userProfile.value === null) return false
    return currentCast.value.isModerator(userProfile.value.id) ?? false
  })
  return {
    isModerator,
    userPreviewQuality
  }
}

export default useCastUserStatus
